// extracted by css-extract-rspack-plugin
export default {"cls1":"PublishingNavbar-cls1_4ut","cls2":"PublishingNavbar-cls2_JZ6 PublishingNavbar-cls1_4ut"};